export const collectionObjectParameters = `
	id: objectID
	objectID
	titles {
		primary {
			title
		}
	}
	artists {
		primary {
			displayName
			constituentID
			nationality
			prefix
			role
			roleID
		}
		all {
			displayName
			constituentID
			nationality
			prefix
			role
			roleID
		}
	}
	period
	date
	extendedStatuses
	culture
	medium
	dimensions
	creditLine
	accessionNumber
	rightsAndReproduction
	webLabel
	images {
			primary {
					openAccess
					objectID
					mainImageUrl
					altText
			}
	}
	location { gallery, onView }
	extendedStatuses
`;
